import { resolveNoContent, resolveWithBody } from "./Utils/utils";
import { usePromisedRequest as promiseRequest } from "../Common/request";

export const SortingTypeEnum = {
    None: 0,
    EnsureBreak: 1,
    ManualOrder: 2,
    RoundBased: 3,
    RoundBasedBeginCategoriesAtTheSameTime: 4,
} as const;

export type SortingType = (typeof SortingTypeEnum)[keyof typeof SortingTypeEnum];

export type RequestedMat = {
    scheduleId: number;
    matId: number;
};

export type MatAutOrderingState = {
    id: number;
    matName: string;
    state: SortingType;
};

export type ScheduleAutoOrderingState = {
    id: number;
    scheduleName: number;
    matStates: MatAutOrderingState[];
};

export default {
    getAutoOrderingStateSummary(eventId: number): Promise<ScheduleAutoOrderingState[]> {
        return promiseRequest<ScheduleAutoOrderingState[]>({
            url: `/api/admin/events/${eventId}/auto-ordering/summary`,
            json: true,
            method: "get",
        }).then(resolveWithBody());
    },
    autoOrderFights(eventId: number, type: SortingType, requestedMats: RequestedMat[], numberOfFightsForBreak: number | null) {
        const breakSize = type === SortingTypeEnum.EnsureBreak ? numberOfFightsForBreak : null;

        return promiseRequest({
            url: `/api/admin/events/${eventId}/auto-ordering`,
            method: "post",
            json: {
                type: type,
                requestedMats: requestedMats,
                numberOfFightsForBreak: breakSize,
            },
        }).then(resolveNoContent());
    },
};
